<template>
    <div class="news_home">
        <div class="courses1">
            <div class="c1_cont">
                <div class="cn">留学资讯</div>
                <div class="en">ART NEWS</div>
            </div>
        </div>
        <div class="news2">
            <div class="section_box">
                <div class="section_title_cn">热门国家申请攻略</div>
                <div class="section_title_en">APPLICATION REQUIREMENTS</div>
            </div>
            <div class="n2_cont">
                <img src="../img/留学资讯/Group 648.png" alt="" class="n2_item" @click="countryDetail(0)">
                <img src="../img/留学资讯/Group 649.png" alt="" class="n2_item" @click="countryDetail(1)">
                <img src="../img/留学资讯/Group 650.png" alt="" class="n2_item" @click="countryDetail(2)">
                <img src="../img/留学资讯/Group 651.png" alt="" class="n2_item" @click="countryDetail(3)">
                <img src="../img/留学资讯/Group 652.png" alt="" class="n2_item" @click="countryDetail(4)">
                <img src="../img/留学资讯/Group 653.png" alt="" class="n2_item" @click="countryDetail(5)">
            </div>
            <div class="n2_cont2">
                <div class="n2_cha">
                    <div class="cha" @click="clickCha">
                        <div class="cha_line1"></div>
                        <div class="cha_line2"></div>
                    </div>
                </div>
                <div class="n2_p">
                    <img src="../img/留学资讯/Group 540.png" alt="">
                    <p>申请时间：</p>
                    <div>{{theCountryData.time}}</div>
                </div>
                <div class="n2_p">
                    <img src="../img/留学资讯/Group 541.png" alt="">
                    <p>语言要求：</p>
                    <div>{{theCountryData.language}}</div>
                </div>
                <div class="n2_p">
                    <img src="../img/留学资讯/Group 542.png" alt="">
                    <p>申请材料：</p>
                    <div>{{theCountryData.material}}</div>
                </div>
                <div class="n2_p">
                    <img src="../img/留学资讯/Group 543.png" alt="">
                    <p>绩点要求：</p>
                    <div>{{theCountryData.gpa}}</div>
                </div>
                <div class="n2_p">
                    <img src="../img/留学资讯/Group 544.png" alt="">
                    <p>文书要求：</p>
                    <div>{{theCountryData.writ}}</div>
                </div>
            </div>
            
        </div>
        <div class="news3">
            <div class="section_box">
                <div class="section_title_cn">留学资讯</div>
                <div class="section_title_en">ART NEWS</div>
            </div>
            <div class="n3_title_box">
                <div class="n3_title_item" @click="getArtsNewsID(0,0)">全部资讯</div>
                <div class="n3_title_item" @click="getArtsNewsID(1,1)">院校及专业</div>
                <div class="n3_title_item" @click="getArtsNewsID(30,2)">导师经验说</div>
                <div class="n3_title_item" @click="getArtsNewsID(11,3)">学生分享</div>
                <div class="n3_title_item" @click="getArtsNewsID(3,4)">热门活动</div>
                <div class="n3_title_item" @click="getArtsNewsID(2,5)">留学攻略</div>
            </div>
            <div class="n3_cont">
                <div class="n3_item" v-for="(item,index) in artsNewsData" @click="jopNewsDetail(item.id)">
                    <img :src="'https://public.rossoarts.com/static/uploads/article/'+item.list_img" alt="">
                    <div>{{ item.title }}</div>
                </div>
                <div class="s3_more" @click="getmoreSchool()">
                    <div>查看更多</div>
                    <div class="s3_more_line1"></div>
                    <div class="s3_more_line2"></div>
                </div>
            </div>
        </div>


    </div>
</template>
<script>
import "@/assets/css/news.css"
import axios from 'axios'
export default {
    data() {
        return {
            artsNewsData:[],
            artsNewClass:0,
            limit:5,
            total:"",
            countryData: [
                {
                    time: "11月至次年1月",
                    material: "作品集、1-2本sketchbook",
                    language: "雅思5.5分以上/托福80分以上",
                    gpa: "大部分院校要求3.0以上",
                    writ: "包括个人陈述、Eassy、推荐信等书面材料，具体以学校要求为准"
                },
                {
                    time: "10月中旬至次年1月中旬",
                    material: "作品集、语言成绩、SAT／ACT",
                    language: "托福80分以上／雅思6分以上",
                    gpa: "大部分院校要求3.0以上",
                    writ: "包括个人陈述、Eassy、推荐信等书面材料，具体以学校要求为准"
                },

                {
                    time: "9月至次年2月",
                    material: "文书材料、作品集、日语成绩、大学成绩单",
                    language: "日语，成绩需要达到 N1/300分以上",
                    gpa: "大部分院校要求3.2以上",
                    writ: "包括研究计划（论文）、成绩证明书、推荐信等，具体以学校要求为准"
                },
                {
                    time: "12月至次年5月",
                    material: "作品集、德语证明、表格式简历、本科毕业证和学位证",
                    language: "德语，申请时达到B1，入学时达到C1",
                    gpa: "大部分院校要求3.2以上",
                    writ: "具体以学校要求为准"
                },
                {
                    time: "12月至次年2月",
                    material: "作品集、语言成绩、毕业证／在读证明、成绩单、申请文书",
                    language: "托福80分以上／雅思6分以上",
                    gpa: "gpa3.0以上",
                    writ: "包括个人陈述、推荐信等书面材料，具体以学校要求为准"
                },
                {
                    time: "8月至12月",
                    material: "作品集、语言成绩、毕业证／在读证明、成绩单、申请文书",
                    language: "托福80分以上／雅思6分以上",
                    gpa: "gpa3.0以上",
                    writ: "包括个人陈述、推荐信等书面材料，具体以学校要求为准"
                },
            ],
            theCountryData: {
                time: "11月至次年1月",
                material: "作品集、1-2本sketchbook",
                language: "雅思5.5分以上/托福80分以上",
                gpa: "大部分院校要求3.0以上",
                writ: "包括个人陈述、Eassy、推荐信等书面材料，具体以学校要求为准"
            },
        }
    },
    created() {
        this.getArtsNews()
    },
    methods: {
        jopNewsDetail(val){
            this.$router.push(`/news/${val}.html`)
        },
        clickCha(){
            var n2_cont2 = document.getElementsByClassName("n2_cont2")
            var n2_cont = document.getElementsByClassName("n2_cont")
            n2_cont2[0].style.display = "none"
            n2_cont[0].style.display = "flex"
        },
        countryDetail(val){
            var n2_cont2 = document.getElementsByClassName("n2_cont2")
            var n2_cont = document.getElementsByClassName("n2_cont")
            n2_cont2[0].style.display = "flex"
            n2_cont[0].style.display = "none"
            this.theCountryData = this.countryData[val]
        },
        getArtsNews() {
            
            axios.get(`https://public.rossoarts.com/api/v1/getArtsNews?category=${this.artsNewClass}&limit=${this.limit}&page=1`).then((data) => {
                this.artsNewsData = data.data.data.data
                this.total = data.data.data.total
                // console.log(data.data.data);
                // this.qaTotal = data.data.data.total
            })
        },
        getArtsNewsID(val,val2){
            this.limit = 5
            this.artsNewClass = val
            this.getArtsNews()
            var s3_more = document.getElementsByClassName("s3_more")
            var n3_title_item = document.getElementsByClassName("n3_title_item")
            s3_more[0].style.display = "flex"
            for(var i=0;i<n3_title_item.length;i++){
                n3_title_item[i].style.backgroundColor = '#fff'
                n3_title_item[i].style.color = '#000'
                n3_title_item[i].style.fontWeight = '400'
            }
            n3_title_item[val2].style.backgroundColor = '#5F9DF7'
            n3_title_item[val2].style.color = '#fff'
            n3_title_item[val2].style.fontWeight = 'bold'
        },
        getmoreSchool(){
            var s3_more = document.getElementsByClassName("s3_more")
            this.limit +=5
            if(this.total<this.limit ||this.total==this.limit ){
                console.log("超");
                
                s3_more[0].style.display = "none"
            }else{
                s3_more[0].style.display = "flex"
            }
            this.getArtsNews()
        }
    }
}
</script>